/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Line_By_LineInputs */

const en_highlight_settings_line_by_line = /** @type {(inputs: Highlight_Settings_Line_By_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line by line`)
};

const es_highlight_settings_line_by_line = /** @type {(inputs: Highlight_Settings_Line_By_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Línea por línea`)
};

/**
* | output |
* | --- |
* | "Line by line" |
*
* @param {Highlight_Settings_Line_By_LineInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_line_by_line = /** @type {((inputs?: Highlight_Settings_Line_By_LineInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Line_By_LineInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_line_by_line(inputs)
	return en_highlight_settings_line_by_line(inputs)
});